import { render } from "./IntroRunoff.vue?vue&type=template&id=46687f42"
import script from "./IntroRunoff.vue?vue&type=script&lang=js"
export * from "./IntroRunoff.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__